import PropTypes from 'prop-types';

// ==============================|| PRESET THEME - DEFAULT ||============================== //

const Default = (colors) => {
  const { red, gold, green, grey } = colors;
  const greyColors = {
    0: grey[0],
    50: grey[1],
    100: grey[2],
    200: grey[3],
    300: grey[4],
    400: grey[5],
    500: grey[6],
    600: grey[7],
    700: grey[8],
    800: grey[9],
    900: grey[10],
    A50: grey[15],
    A100: grey[11],
    A200: grey[12],
    A400: grey[13],
    A700: grey[14],
    A800: grey[16]
  };
  const contrastText = '#fff';

  // Custom primary color palette - Black (#1E1E1E)

  const primaryColors = [
    '#D9E5F2', // lighter
    '#B2CBE5', // 100
    '#8CB1D9', // 200
    '#6697CC', // light
    '#336499', // 400
    '#13263A', // main
    '#00184D', // dark
    '#000B40', // 700
    '#000338', // darker
    '#000136'  // 900
  ];

  const tertiaryColors = [
    '#F5F5F5', // lighter
    '#E0E0E0', // 100
    '#CCCCCC', // 200
    '#B8B8B8', // light
    '#787878', // 400
    '#1E1E1E', // main
    '#161616', // dark
    '#0F0F0F', // 700
    '#0A0A0A', // darker
    '#000000'  // 900
  ];

  const secondaryColors = [
    '#F0F0F5', // lighter
    '#E0E0EB', // 100
    '#C2C2D6', // 200
    '#A3A3C2', // light
    '#8484AD', // 400
    '#666699', // main
    '#51517A', // 600
    '#383861', // dark
    '#1E1E47', // 800
    '#05052E'  // 900
  ];

  return {
    primary: {
      lighter: primaryColors[0],
      100: primaryColors[1],
      200: primaryColors[2],
      light: primaryColors[3],
      400: primaryColors[4],
      main: primaryColors[5],
      dark: primaryColors[6],
      700: primaryColors[7],
      darker: primaryColors[8],
      900: primaryColors[9],
      contrastText
    },
    secondary: {
      lighter: secondaryColors[0],
      100: secondaryColors[1],
      200: secondaryColors[2],
      light: secondaryColors[3],
      400: secondaryColors[4],
      main: secondaryColors[5],
      600: secondaryColors[6],
      dark: secondaryColors[7],
      800: secondaryColors[8],
      darker: secondaryColors[9],
      A100: greyColors[0],
      A200: greyColors.A400,
      A300: greyColors.A700,
      contrastText: '#fff'
    },
    error: {
      lighter: red[0],
      light: red[2],
      main: red[4],
      dark: red[7],
      darker: red[9],
      contrastText
    },
    warning: {
      lighter: gold[0],
      light: gold[3],
      main: gold[5],
      dark: gold[7],
      darker: gold[9],
      contrastText: greyColors[100]
    },
    info: {
      lighter: tertiaryColors[0],
      light: tertiaryColors[3],
      main: tertiaryColors[5],
      dark: tertiaryColors[7],
      darker: tertiaryColors[9],
      contrastText
    },
    success: {
      lighter: green[0],
      light: green[3],
      main: green[5],
      dark: green[7],
      darker: green[9],
      contrastText
    },
    grey: greyColors
  };
};

Default.propTypes = {
  colors: PropTypes.object
};

export default Default;
